import React from "react";
import CompanyImg from "./CompanyImg";
import "./companies.css";

function Companies() {
  return (
    <div className="companies">
      <h1>We Helped More Than 1000 Companies</h1>
      <CompanyImg />
    </div>
  );
}

export default Companies;
